import { render, staticRenderFns } from "./TournamentEditMatchControl.vue?vue&type=template&id=42b8e555&scoped=true"
import script from "./TournamentEditMatchControl.vue?vue&type=script&lang=js"
export * from "./TournamentEditMatchControl.vue?vue&type=script&lang=js"
import style0 from "./TournamentEditMatchControl.vue?vue&type=style&index=0&id=42b8e555&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b8e555",
  null
  
)

export default component.exports